"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = usePortalPlaceholder;

var _react = _interopRequireWildcard(require("react"));

var _context = _interopRequireDefault(require("@sift/skipper/components/PortalProvider/context"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function usePortalPlaceholder(Portal) {
  var portalId = Portal.__portalId;

  function PortalPlaceholder(props) {
    var rootRef = (0, _react.useRef)(null);
    var portalContext = (0, _react.useContext)(_context["default"]);

    if (!portalContext) {
      throw new Error('[usePortalPlaceholder] could not find portal context');
    }

    var setContentEl = portalContext.setContentEl,
        removeContentEl = portalContext.removeContentEl;
    (0, _react.useEffect)(function () {
      var rootEl = rootRef.current;

      if (!rootEl) {
        throw new Error('[usePortalPlaceholder] rootRef was falsy');
      }

      setContentEl(portalId, rootEl);
      return function () {
        return removeContentEl(portalId);
      };
    }, [setContentEl, removeContentEl]);
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      ref: rootRef
    }, props));
  }

  return PortalPlaceholder;
}